import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { afiliacionesReducer } from "./afiliacionesReducer";
import { seccionalesReducer } from "./cbos/seccionalesReducer";
import { localidadesReducer } from "./cbos/localidadesReducer";
import { provinciasReducer } from "./cbos/provinciasReducer";
import { categoriasReducer } from "./cbos/categoriasReducer";
import { motivosBajaReducer } from "./cbos/motivosBajaReducer";
import { alertReducer } from "./alertReducer";
import { spinnerReducer } from "./spinnerReducer";
import {
  tipoDocumentacionParentescoReducer,
  tipoDocumentacionTipoAfiliacionReducer,
} from "./documentacion/documentacionReducer";
import { documentacionAfiliacionReducer } from "./documentacion/documentacionAfiliadoReducer";
import { grupoFamiliarReducer } from "./grupoFamiliarReducer";
import { observacionesReducer } from "./observacionesReducer";
import { empresasAfiliadoReducer } from "./empresasAfiliadoReducer";
import { aportesAfiliadoReducer } from "./aportesAfiliadoReducer";
import { aportesPreafiliadoReducer } from "./aportesPreafiliadoReducer";
import { usuariosReducer } from "./usuarios/usuariosReducer";
import { conveniosPrestacionalesReducer } from "./cbos/conveniocPrestacionalesReducer";
import { planesReducer } from "./cbos/planesReducer";
import { empresasReducer } from "./empresas/empresasReducer";
import { certificadosAfiliacionReducer } from "./certificados/certificadosAfiliadoReducer";
import { configuracionesReducer } from "./configuraciones/configuracionReducer";
import { abmReducer } from "./abm/abmReducer";
import { abmAfiliacionReducer } from "./abm/abmAfiliacionReducer";
import { abmParentescoReducer } from "./abm/abmParentescoReducer";
import { afiliadoReducer } from "./preAfiliado/afiliadoReducer";
import { tipoRelacionReducer } from "./tipoRelacion/tipoRelacionReducer";
import { grupoFamiliarPreinscriptoReducer } from "./grupoFamiliarPreinscriptoReducer";
import { rolesReducer } from "./usuarios/rolesReducer";
import { permisosReducer } from "./usuarios/permisosReducer";
import { areasReducer } from "./usuarios/areasReducer";
import { familiarSeleccionadoReducer } from "./familiarSeleccionadoReducer";
import { empresasPreafiliadoReducer } from "./empresasPreafiliadoReducer";
import { parentescoReducer } from "./cbos/parentescoReducer";
import { notificacionReducer } from "./notificacionReducer";
import { stepperReducer } from "./preAfiliado/stepperReducer";
import { bandejaReducer } from "./bandejaReducer";
import { stateProvisorioReducer } from "./preAfiliado/stateProvisorioReducer";
import { observacionesPreafiliadosReducer } from "./preAfiliado/observacionesPreafiliadosReducer";
import { grupoFamiliarCambioTitularidadReducer } from "./grupoFamiliarCambioTitularidadReducer";
import { indicadoresReducer } from "./indicadoresReducer";
import { configuracionesCategoriaReducer } from "./configuraciones/configuracionesCategoriaReducer";
import { preAfiliacionesTomadasReducer } from "./preAfiliacionesTomadasReducer";
import { abmCategoriaReducer } from "./abm/abmCategorias";
import { candidatosBajaReducer } from "./candidatosBajaReducer";
import { abmEstadoCivilReducer } from "./abm/abmEstadoCivilReducer";
import { userAutogetionReducer } from "./userAutogestion/userAutogestionReducer";
import { reportesReducer } from "./reportesReducer";
import { movimientosReducer } from "./movimientos/movimientosReducer";
import { contactosReducer } from "./contactos/contactosReducer";
import { causaBajasReducer } from "./cbos/causaBajasReducer";
import { movimientosUserReducer } from "./movimientosUser/movimientosUserReducer";
import { agendaReducer } from "./turnos/agendaReducer";
import { motivosBajaTurnoReducer } from "./turnos/motivosBajaTurnoReducer";
import { efectoresPReducer } from "./contratos/efectorPReducer";
import { AfiliadoVariosReducer } from "./afiliados/AfiliadoVariosReducer";
import { AfiliadoTurnosReducer } from "./afiliados/AfiliadoTurnosReducer";
import { centrosMedicosPropiosReducer } from "./centrosMedicosPropiosReducer";
import { cambiosAgendaReducer } from "./turnos/cambiosAgendaReducer";
import { efectorHorariosReducer } from "./turnos/efectorHorariosReducer";
import { feriadosReducer } from "./turnos/feriadosReducer";
import { resolucionesReducer } from "./facturacion/resolucionesReducer";
import { cuotasReducer } from "./facturacion/cuotasReducer";
import { facturasAfiliadoReducer } from "./facturacion/facturasAfiliadoReducer";
import { ArchivosMigracionReducer } from "./ArchivosMigracionReducer";
import { medicosAbmReducer } from "./medicosAbm/medicosAbmReducer";
import { especialidadesReducer } from "./especialidadesReducer";
import { especialidadAbmReducer } from "./abm/abmEspecialidad";
import { documentacionPresentadaReducer } from "./preAfiliado/documentacionPresentadaReducer";
import { licenciasProfesionalesReducer } from "./turnos/licenciasProfesionalesReducer";
import { AfiliadoReactivacionReducer } from "./afiliados/AfiliadoReactivacionReducer";
import { TipoEfectoresReducer } from "./tipoEfectoresReducer";
import { TipoDocumentacionesEfectorReducer } from "./contrataciones/configuraciones/abmTipoDocumentacionesEfector";
import { contratacionesReducer } from "./contrataciones/contratacionesReducer";
import { contratacionesContactosReducer } from "./contrataciones/contratacionesContactosReducer";
import { contratacionesDatosContablesReducer } from "./contrataciones/contratacionesDatosContablesReducer";
import { contratacionesDocumentacionReducer } from "./contrataciones/contratacionesDocumentacionReducer";
import { contratacionesCartillaReducer } from "./contrataciones/contratacionesCartillaReducer";
import { contratacionesConveniosReducer } from "./contrataciones/contratacionesConveniosReducer";
import { TopesMinimosabmReducer } from "./abm/TopesMinimosabmReducer";
import { abmMotivosBajaEfectorReducer } from "./contrataciones/configuraciones/abmMotivosBajaEfectorReducer";
import { abmPlazosReducer } from "./contrataciones/configuraciones/ambPlazosReducer";
import { propuestaFacturacionReducer } from "./facturacion/propuestaFacturacionReducer";
import { cosegurosReducer } from "./coseguros/cosegurosReducer";
import { ctaCteReducer } from "./turnos/ctaCteReducer";
import { EstadisticasMiOspedycReducer } from "./EstadisticasMiOspedycReducer";
import { AutorizacionesReducer } from "./autorizaciones/AutorizacionesReducer";
import { contratacionesReportesReducer } from "./contrataciones/contratacionesReportesReducer";
import { bandejasAutorizacionReducer } from "./usuarios/bandejasAutorizacionReducer";
import { subAreasContratacionesReducer } from "./usuarios/subAreasContratacionesReducer";
import { abmModulosReducer } from "./contrataciones/configuraciones/abmModulosReducer";
import { abmCosegurosReducer } from "./contrataciones/configuraciones/abmCosegurosReducer";
import { abmMaterialesReducer } from "./autorizaciones/abmMaterialesReducer";
import { nomencladoresReducer } from "./nomencladoresReducer";
import { contratacionesModulosReducer } from "./contrataciones/contratacionesModulosReducer";
import { contratacionesInclusionesExclusionesReducer } from "./contrataciones/contratacionesInclusionesExclusionesReducer";
import { trackingAbmReducer } from "./trackingAbmReducer";
import { cartillaMiOspedycReducer } from "./cartillaMiOspedycReducer";
import { abmUsuarioPorIdProfesionalReducer } from "./turnos/abmrUsuarioPorIdProfesionalReducer";
import { mesaEntradaReducer } from "./mesaEntrada/mesaEntradaReducer";
import { archivosContratacionesReducer } from "./archivosContratacionesReducer";
import { contratacionesLegalesReducer } from "./contrataciones/contratacionesLegalesReducer";
import { efectoresPorLiquidadorReducer } from "./liquidaciones/efectoresPorLiquidadorReducer";
import {abmFormulariosMiOspedycReducer} from "./miOspedyc/abmFormulariosMiOspedycReducer";
import { RecetasDigitalesReducer } from "./recetasDigitales/RecetasDigitalesReducer";
import { MedicamentosReducer } from "./recetasDigitales/MedicamentosReducer";
import { liquidacionesReducer } from "./liquidaciones/liquidacionesReducer";
import { proveedoresReducer } from "./compras/proveedoresReducer";
import { comprasReducer } from "./compras/comprasReducer";
import { cobraCoseguroReducer } from "./cobraCoseguroReducer";
import { medioPagoReducer } from "./cbos/medioPagoReducer";
import { discapacidadReducer } from "./discapacidad/discapacidadReducer";
import { EmpadronamientoReducer } from "./empadronamiento/EmpadronamientoReducer";
import { TiposEmpadronamientoReducer } from "./empadronamiento/TiposEmpadronamientoReducer";
import { AfiliadoDiscapacidadReducer } from "./afiliados/AfiliadoDiscapacidadReducer";
import { areasFisicasReducer } from "./usuarios/areasFisicasReducer";
import { subAreasFisicasReducer } from "./usuarios/subAreasFisicasReducer";
import {AuditoriaFacturacionReducer} from "./compras/AuditoriaFacturacionReducer";
import { surgeReducer } from "./recuperos/surgeReducer";
import { Medicamentos310Reducer } from "./empadronamiento/Medicamentos310Reducer";
import { relacionMedicoPracticaReducer } from "./turnos/relacionMedicoPracticaReducer";
import { reclamosReducer } from "./reclamos/reclamosReducer";
import { totemReducer } from "./totem/totemReducer";
import {comunicacionConEmpresasReducer} from "./comunicacionConEmpresas/comunicacionConEmpresasReducer";
import { NomencladorDiscapacidadReducer } from "./discapacidad/nomencladorDiscapacidadReducer";
import { hceReducer } from "./HCE/HceReducer";
import { obrasSocialesReducer } from "./obrasSocialesReducer";
import { trasladosReducer } from "./traslados/trasladosReducer";
import { ambCosegurosExternosReducer } from "./contrataciones/configuraciones/abmCosegurosExternosReducer";
import { abmPrestadoresRestringidos } from "./autorizaciones/abmPrestadoresRestringidosReducer";
import { abmVersionadoReducer } from "./versionado/versionadoReducer";
import { laboratorioReducer } from './turnos/laboratorioReducer';
import { CertificadoAtencionReducer } from "./turnos/certificadoAtencionReducer";
import { adiccionesReducer } from "./adicciones/adiccionesReducer";
import { practicasAgrupadasReducer } from './autorizaciones/practicasAgrupadasReducer';
import { usuariosOspeDirectoReducer } from "./tesoreria/usuariosOspeDirectoReducer";
import { EstudiosMedicosReducer } from "./turnos/estudiosMedicos";
import { totemBasicReducer } from "./totemBasic/totemBasicReducer";

export const rootReducer = combineReducers({
  abmCoseguros: abmCosegurosReducer,
  abmMateriales: abmMaterialesReducer,
  auth: authReducer,
  afiliacion: afiliacionesReducer,
  afiliadoReactivacion: AfiliadoReactivacionReducer,
  afiliadoTurnos: AfiliadoTurnosReducer,
  afiliadoVarios: AfiliadoVariosReducer,
  archivosMigracion: ArchivosMigracionReducer,
  agenda: agendaReducer,
  alert: alertReducer,
  aportesAfiliado: aportesAfiliadoReducer,
  aportesPreafiliado: aportesPreafiliadoReducer,
  areas: areasReducer,
  autorizaciones: AutorizacionesReducer,
  bandeja: bandejaReducer,
  cambiosAgenda: cambiosAgendaReducer,
  candidatosBaja: candidatosBajaReducer,
  categoriaAux: abmCategoriaReducer,
  categorias: categoriasReducer,
  causaBajas: causaBajasReducer,
  cartillaMiOspedyc: cartillaMiOspedycReducer,
  centrosMedicosPropios: centrosMedicosPropiosReducer,
  certificadosAfiliacion: certificadosAfiliacionReducer,
  configuraciones: configuracionesReducer,
  configuracionesCategoria: configuracionesCategoriaReducer,
  contactosWeb: contactosReducer,
  contrataciones: contratacionesReducer,
  contratacionesContactos: contratacionesContactosReducer,
  contratacionesLegales: contratacionesLegalesReducer,
  contratacionesDatosBancarios: contratacionesDatosContablesReducer,
  contratacionesDocumentacion: contratacionesDocumentacionReducer,
  contratacionesCartilla: contratacionesCartillaReducer,
  contratacionesConvenios: contratacionesConveniosReducer,
  conveniosPrestacionales: conveniosPrestacionalesReducer,
  contratacionesReportes: contratacionesReportesReducer,
  contratacionesModulos: contratacionesModulosReducer,
  contratacionesInclusionesExclusiones: contratacionesInclusionesExclusionesReducer,
  ctaCte: ctaCteReducer,
  coseguros: cosegurosReducer,
  cuotas: cuotasReducer,
  documentacionAfiliacion: documentacionAfiliacionReducer,
  documentacionPresentada: documentacionPresentadaReducer,
  documentos: abmReducer,
  efectoresP: efectoresPReducer,
  efectorHorarios: efectorHorariosReducer,
  empresas: empresasReducer,
  empresasAfiliado: empresasAfiliadoReducer,
  empresasPreafiliado: empresasPreafiliadoReducer,
  estadoCivil: abmEstadoCivilReducer,
  especialidades: especialidadesReducer,
  especialidadAbm: especialidadAbmReducer,
  estadisticasMiOspedyc: EstadisticasMiOspedycReducer,
  facturasAfiliado: facturasAfiliadoReducer,
  familiarSeleccionado: familiarSeleccionadoReducer,
  feriados: feriadosReducer,
  formulariosMiOspedyc: abmFormulariosMiOspedycReducer,
  grupofamiliar: grupoFamiliarReducer,
  grupoFamiliarCambioTitularidad: grupoFamiliarCambioTitularidadReducer,
  grupofamiliarPreinscripto: grupoFamiliarPreinscriptoReducer,
  indicadores: indicadoresReducer,
  laboratorio: laboratorioReducer,
  licenciasProfesionales: licenciasProfesionalesReducer,
  liquidaciones: liquidacionesReducer,
  localidades: localidadesReducer,
  medioPago: medioPagoReducer,
  medico: medicosAbmReducer,
  modulosContratos: abmModulosReducer,
  motivosBajaTurno: motivosBajaTurnoReducer,
  movimientos: movimientosReducer,
  movimientosUser: movimientosUserReducer,
  motivosBaja: motivosBajaReducer,
  motivosBajaEfector: abmMotivosBajaEfectorReducer,
  listaPlazos: abmPlazosReducer,
  bandejasAutorizacion: bandejasAutorizacionReducer,
  nomencladores: nomencladoresReducer,
  notificacion: notificacionReducer,
  observacionesAfiliacion: observacionesReducer,
  observacionesPreafiliados: observacionesPreafiliadosReducer,
  parentescos: parentescoReducer,
  surge: surgeReducer,
  permisos: permisosReducer,
  planes: planesReducer,
  preAfiliacionesTomadas: preAfiliacionesTomadasReducer,
  preinscripto: afiliadoReducer,
  propuestaFacturacion: propuestaFacturacionReducer,
  provincias: provinciasReducer,
  reportes: reportesReducer,
  proveedores: proveedoresReducer,
  resoluciones: resolucionesReducer,
  roles: rolesReducer,
  seccionales: seccionalesReducer,
  spinner: spinnerReducer,
  stateProvisorio: stateProvisorioReducer,
  stepper: stepperReducer,
  tipoAfiliaciones: abmAfiliacionReducer,
  tipoDocumentacionParentesco: tipoDocumentacionParentescoReducer,
  tipoDocumentacionTipoAfiliacion: tipoDocumentacionTipoAfiliacionReducer,
  tipoDocumentacionesEfectores: TipoDocumentacionesEfectorReducer,
  tipoParentescos: abmParentescoReducer,
  tipoSubtipoEfectores: TipoEfectoresReducer,
  tipoRelaciones: tipoRelacionReducer,
  topesMinimos: TopesMinimosabmReducer,
  trackingAbm: trackingAbmReducer,
  userAutogestion: userAutogetionReducer,
  usuarios: usuariosReducer,
  abmUsuarioPorIdProfesional: abmUsuarioPorIdProfesionalReducer,
  mesaEntrada: mesaEntradaReducer,
  archivosContrataciones: archivosContratacionesReducer,
  efectoresPorLiquidador: efectoresPorLiquidadorReducer,
  subAreasContrataciones: subAreasContratacionesReducer,
  recetasDigitales: RecetasDigitalesReducer,
  medicamentos: MedicamentosReducer,
  compras : comprasReducer, 
  cobraCoseguro : cobraCoseguroReducer, 
  discapacidad: discapacidadReducer,
  nomencladorDiscapacidad: NomencladorDiscapacidadReducer,
  empadronamiento: EmpadronamientoReducer,
  tiposEmpadronamiento: TiposEmpadronamientoReducer,
  afiliadoDiscapacidad: AfiliadoDiscapacidadReducer,
  areasFisicas: areasFisicasReducer,
  subAreasFisicas: subAreasFisicasReducer,
  auditoriaFacturacion: AuditoriaFacturacionReducer,
  medicamentos310: Medicamentos310Reducer,
  relacionMedicoPractica: relacionMedicoPracticaReducer,
  reclamos: reclamosReducer,
  totem: totemReducer,
  comunicacionEmpresas : comunicacionConEmpresasReducer,
  hce: hceReducer,
  obrasSociales: obrasSocialesReducer,
  traslados: trasladosReducer,
  cosegurosExternos: ambCosegurosExternosReducer,
  prestadoresRestringidos: abmPrestadoresRestringidos,
  versionado: abmVersionadoReducer,
  certificadoAtencion: CertificadoAtencionReducer,
  adicciones: adiccionesReducer,
  practicasAgrupadas: practicasAgrupadasReducer,
  usuariosOspeDirecto : usuariosOspeDirectoReducer,
  estudiosMedicos: EstudiosMedicosReducer,
  totemBasic: totemBasicReducer,
});
